import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as roleActions from "../../actions/roleActions";
import * as loaderActions from "../../actions/loaderActions";

const UserRolesSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  roles = [],
  actions,
  loading
}) => {
  const fetchRoles = useCallback(async () => {
    await actions.loadRoles();
    actions.toggleLoader(false);
  }, [actions]);

  useEffect(() => {
    if (!roles.length) {
      actions.toggleLoader(true);
      fetchRoles();
    }
  }, [actions, roles.length, fetchRoles]);

  const options = roles
    .map((r) => ({
      label: r.name,
      value: r._id
    }))
    .sort((a, b) => {
      if (a.label > b.label) return 1;
      if (b.label > a.label) return -1;
      return 0;
    });

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) =>
          initialValue.find((i) => i === x.value || i.value === x.value)
        )
      : initialValue;

  return (
    <Select
      id="role-select"
      name="roles"
      className="react-select-container"
      classNamePrefix="react-select-container"
      fullwidth
      placeholder="Role(s)"
      value={value}
      options={options}
      isClearable
      isLoading={loading}
      onChange={onChange}
      isMulti={isMulti}
    />
  );
};

UserRolesSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  roles: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  loading: PropTypes.bool
};

UserRolesSelect.defaultProps = {
  loading: false
};

function mapStatesToProps(state) {
  return {
    roles: state.reducers.roles,
    role: state.reducers.role
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...roleActions,
        ...loaderActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserRolesSelect);
